// extracted by mini-css-extract-plugin
export default {"container":"Login_container__guQYQ","block":"Login_block__vu6li","authContainer":"Login_authContainer__AydVz","mainTitle":"Login_mainTitle__Iy10Z","grid":"Login_grid__HK1wC"};